import React from 'react';

import './styles.css';

import Person from '../person';

export default class About extends React.Component {
  render() {
    return (
      <div className="Contact Content" ref="dom">
        <h2 className="Title Title__center" id="hafa-samband">Hafa samband</h2>
        <div className="Contacts">
          <div className="Contacts-person">
            <Person
              name="binni"
              fullName="Brynjar Sveinbjörnsson"
              phone="+3548526111"
              phoneDisplay="+354 852 6111"
              email="binni@steinkompaniid.is"
            />
          </div>
          <div className="Contacts-person">
            <Person
              name="thor"
              fullName="Þór Sigmundsson"
              phone="+3548527111"
              phoneDisplay="+354 852 7111"
              email="thor@steinkompaniid.is"
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/contact/index.js